import ar from "./ar";
import en from "./en";

/*
 * payment-channels translations live outside the shared dictionary so only this
 * feature's pages download them.
 */
export const paymentChannelsTextByLocale = { ar, en };

export function getPaymentChannelsText(locale) {
  return paymentChannelsTextByLocale[locale] ?? paymentChannelsTextByLocale.ar;
}
